import { Routes, Route } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useNavbar } from '../context/NavbarContext';
import Home from '../pages/Home';
import SymptomChecker from '../pages/SymptomChecker';
import DoctorsAppointment from '../pages/Doctors';         

// Define which routes should use light navbar
const LIGHT_NAVBAR_ROUTES = [
  '/womens-care',
  '/child-care',
  '/behavioral-health',
];

const AppRoutes = () => {
  const location = useLocation();
  const { setVariant } = useNavbar();

  useEffect(() => {
    // Update navbar variant based on current route
    if (LIGHT_NAVBAR_ROUTES.includes(location.pathname)) {
      setVariant('light');
    } else {
      setVariant('dark');
    }
  }, [location.pathname, setVariant]);
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/symptom-checker" element={<SymptomChecker />} />
      <Route path="/book-appointment" element={<DoctorsAppointment />} />
    </Routes>
  );
};

export default AppRoutes;